export default function (str) {
  if (!str) {
    return null
  }
  const backgroundStr = `url(${str})`;
  return backgroundStr;
}
